module.exports = __webpack_public_path__ + "img/phone-icon-black.78673b75.png";